import { render, staticRenderFns } from "./LatestCompletedSessionItem.vue?vue&type=template&id=4aa55986"
import script from "./LatestCompletedSessionItem.vue?vue&type=script&lang=js"
export * from "./LatestCompletedSessionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports